export const VERSION = '1.49.0'
